import { logger } from "@wayflyer/blackbox-fe";
import { BaseSchemas } from "api-types";

const DEFAULT_PUBLIC_ANALYTICS_ATTRIBUTES: BaseSchemas.PublicAnalyticsAttributes = {
  companyPublicId: null,
  createdAt: null,
  hubspotContactId: null,
  isProductManaged: false,
  isStaff: false,
  isTest: false,
  lastLogin: null,
  userId: null,
  userUuid: null,
};

let hasLoggedMissingAnalyticsAttributes = false;

export const getAnalyticsAttributes = (
  appConfig: Pick<BaseSchemas.CustomerAppConfig, "analyticsAttributes">
): BaseSchemas.AnalyticsAttributes | BaseSchemas.PublicAnalyticsAttributes => {
  if (!appConfig.analyticsAttributes && !hasLoggedMissingAnalyticsAttributes) {
    logger.warn("Customer app config is missing analyticsAttributes. Falling back to public analytics defaults.");
    hasLoggedMissingAnalyticsAttributes = true;
  }

  return appConfig.analyticsAttributes ?? DEFAULT_PUBLIC_ANALYTICS_ATTRIBUTES;
};
